<template>
  <nav class="bg-white shadow-md fixed top-0 w-full z-[9999]">
    <div class="container mx-auto px-4 py-3 flex justify-between items-center">
      <!-- Logo en Titel -->
      <div class="flex items-center space-x-3">
        <img src="vvw.png" alt="Logo Visspecialist van Wijk" class="h-8 w-auto">
        <div class="text-xl font-bold text-sky-700">
          <a href="/" class="hover:text-sky-700">Visspecialist van Wijk</a>
        </div>
      </div>

      <!-- Hamburger Icon for Small Screens -->
      <button 
        @click="toggleMenu" 
        class="md:hidden text-sky-600 focus:outline-none">
        <svg v-if="!isMenuOpen" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
            d="M4 6h16M4 12h16m-7 6h7" />
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
            d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <!-- Menu Links (Desktop) -->
      <ul class="hidden md:flex space-x-8 items-center">
        <li><a href="/#assortiment" class="hover:text-sky-600">Assortiment</a></li>
        <li><a href="/#over-ons" class="hover:text-sky-600">Over ons</a></li>
        <router-link to="/vacatures">
          <li><a class="hover:text-sky-600">Vacatures</a></li>
        </router-link>
        <li>
          <a 
            href="#contact" 
            class="bg-sky-600 text-white px-4 py-2 rounded hover:bg-sky-700 transition">
            Contact
          </a>
        </li>
      </ul>
    </div>

    <!-- Mobile Menu -->
    <transition name="menu-slide" appear>
      <div v-if="isMenuOpen" class="md:hidden bg-white shadow-lg overflow-hidden z-[9999]">
        <ul class="space-y-4 py-4 px-4">
          <li @click="closeMenu"><a href="/#assortiment" class="block text-gray-800 hover:text-sky-600">Assortiment</a></li>
          <li @click="closeMenu"><a href="/#over-ons" class="block text-gray-800 hover:text-sky-600">Over ons</a></li>
          <li @click="closeMenu">
            <a 
              href="#contact" 
              class="block bg-sky-600 text-white px-4 py-2 rounded hover:bg-sky-700 transition">
              Contact
            </a>
          </li>
        </ul>
      </div>
    </transition>
  </nav>
</template>

<script>
export default {
  name: "ResponsiveNavbar",
  data() {
    return {
      isMenuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    goToVacatures() {
      this.$router.push('/vacatures');
    },
  },
};
</script>

<style scoped>
/***** Custom Styling *****/
.menu-slide-enter-active,
.menu-slide-leave-active {
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
.menu-slide-enter-from,
.menu-slide-leave-to {
  max-height: 0;
  opacity: 0;
}
.menu-slide-enter-to,
.menu-slide-leave-from {
  max-height: 500px;
  opacity: 1;
}
</style>
